.wrap {
  padding: 70px 28px 96px;
  text-align: center;
}
.divider {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
}
.line {
  width: 38px;
  height: 1px;
  background: var(--rule);
}
.dot {
  display: inline-block;
  border-radius: 50%;
  background: radial-gradient(circle at 32% 28%, #ffffff 0%, #f5ede2 38%, #e0d4c1 70%, #cdbda4 100%);
}
.dotSmall {
  width: 6px;
  height: 6px;
  box-shadow: 0 1px 3px rgba(120, 100, 70, 0.3);
}
.dotMid {
  width: 11px;
  height: 11px;
  box-shadow: 0 2px 5px rgba(120, 100, 70, 0.3);
}
.eyebrow {
  font-family: var(--font-script);
  font-size: 24px;
  color: var(--pink);
  margin-top: 8px;
}
.title {
  margin: 2px 0 0;
  font-family: var(--font-body);
  font-weight: 400;
  font-size: 27px;
  letter-spacing: 3px;
  text-indent: 2px;
  color: var(--ink-2);
}
.body {
  margin: 14px 0 0;
  font-size: 14.5px;
  line-height: 1.95;
  color: var(--muted);
}
.button {
  margin-top: 20px;
  background: none;
  border: none;
  border-bottom: 1.5px solid var(--pink);
  border-radius: 0;
  padding: 4px 8px 8px;
  font-family: var(--font-body);
  font-weight: 400;
  font-size: 19px;
  letter-spacing: 2px;
  color: var(--pink-deep);
  cursor: pointer;
}
/* 원본 디자인은 버튼의 비활성 상태를 표현하지 않는다 — 예식 전 게이트는 이
   작업에서 새로 추가된 동작이므로, 눌러도 반응이 없다는 것이 보이도록 최소한의
   비활성 스타일을 더한다. */
.button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.hint {
  margin-top: 14px;
  font-family: var(--font-label);
  font-size: 13px;
  letter-spacing: 1px;
  color: var(--muted-4);
}
